module.exports = __webpack_public_path__ + "img/MA.fb679172.svg";